import {Modal} from "antd";
import "./ScreenSetUpModal.scss";
import { CloseOutlined } from "@ant-design/icons";


export interface ScreenSetUpHelpModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export function ScreenSetUpHelpModal({isVisible, onClose}: ScreenSetUpHelpModalProps) {
  return (
    <Modal
      className={"clean screen-set-up set-up-help"}
      visible={isVisible}
      onCancel={() => onClose()}
      width={432}
    >
      <header>
        <CloseOutlined onClick={() => onClose()} className="close-btn"/>
      </header>
      <div className="help-items">
        <p className="item">
          <b>Pairing Code:</b> This is the pairing code you see when you first turn on your player.
        </p>
        <p>
          <b>Placement:</b> This is an optional field. It can be used to identify the physical placement of the screen within your establishment.
        </p>
        <p>
          <b>Orientation:</b> This is the physical orientation of the screen. Portrait (longer edge runs vertically) or Landscape (longer edges runs horizontally).
        </p>
        <p>
          <b>Schedule Reboot:</b> We recommend that you reboot the Skykit player on a regular basis. Set up a reboot schedule during off hours to reboot automatically.
        </p>
      </div>
    </Modal>
  );
}
